// Words that should never be capitalized. Generally limited to particles and
// prepositions.
//
// @note This is only correct for English words.
// @see https://en.wikipedia.org/wiki/Stop_word
const stopWords = ['a', 'an', 'and', 'of', 'on', 'or', 'the', 'to']

export const capitalCase = (input: string): string => {
  const words = input.trim().split(/\s+/gi)

  return words
    .map((word) => {
      if (stopWords.includes(word.toLowerCase())) {
        return word.toLowerCase()
      }

      return word.slice(0, 1).toUpperCase() + word.slice(1, word.length)
    })
    .join(' ')
}
